import React, { useState, useEffect, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "react-snackbar-messages";

import { useAuth } from "../Providers/AuthProvider";
import Header from "../Components/Common/Header/Header";
import CaasFooter from "../Components/Common/Footer/Footer";
//import Loader from "../Components/Loader";
import LoadingSkeletonBox from "../Components/Common/LoadingSkeletonBox";
//import NotFound from "./NotFound";
import { ConcurrentLoginModal } from "../Components/Common/ConcurrentLoginModal";
import IdleTimeOutHandler from "../Components/Common/SessionTimeoutModal/IdleTimeoutHandler";
import { loginServiceApi } from "../Api";
import { handleReposeError } from "../Components/Common/ErrorHandler";
//import { ProgressBar } from "@govtechsg/sgds-react";
//import { Spinner } from "react-bootstrap";
import { getRecaptchaToken } from "../recaptcha";

const Root = () => {
  const navigate = useNavigate();
  const snackbar = useSnackbar();

  const { user, setUser } = useAuth();

  const [isLoadingLogout, setIsLoadingLogout] = useState(false);

  const [isLoadingCurrentUser, setIsLoadingCurrentUser] = useState(true);
  const [isErrorCurrentUser, setIsErrorCurrentUser] = useState(false);

  const [isShowConcurrentLoginModal, setIsShowConcurrentLoginModal] = useState(false);

  const [isActive, setIsActive] = useState(true);

  const showSnackbar = (title, variant) => {
    snackbar.add(title, {
      appearance: variant,
      autoDismiss: true,

    })
  }

  const handleLogout = async () => {

    try {

      setIsLoadingLogout(true);

      const recaptchaToken = await getRecaptchaToken();
      const { data: response } = await loginServiceApi(recaptchaToken).get("/logout");
      setUser({ status: "" });
      navigate("/", { replace: true });
    } catch (error) {
      console.log("Error logout: ", error);
      navigate("/", { replace: true });
    }
    finally {
      setIsLoadingLogout(false);
    }
  };



  const fetchUser = async () => {
    // kk setIsLoadingCurrentUser(true);
    setIsLoadingCurrentUser(true);

    try {
      const url = "/status";
      const recaptchaToken = await getRecaptchaToken();
      const { data: response } = await loginServiceApi(recaptchaToken).get(url);

      if (response.userSessionValid && response.foundMultipleSessions) {
        setIsShowConcurrentLoginModal(true);
      }

      setIsErrorCurrentUser(false);
      setUser(response);
    } catch (error) {
      handleReposeError({
        resp: error.response,
        snackbarFun: (errorMsg) => showSnackbar(errorMsg, "error"),
        setUser: setUser,
        navigate: navigate,
        otherProps: null,
      });

      console.log("Error fetching current user: ", error);
      setIsErrorCurrentUser(true);
      // Reset user so IndexPage can navigate to /home (the public slider page)
      // instead of getting stuck on the placeholder initial state.
      setUser({ status: "" });
    } finally {
      setIsLoadingCurrentUser(false);
    }
  };

  useEffect(() => {


    fetchUser();

    // Run the patch and save its cleanup function
    const cleanupRecaptcha = patchRecaptchaAria();
    return () => {
      cleanupRecaptcha();
    };

  }, []);

  // Function handles both the execution delay and returns the timer cleanup
  const patchRecaptchaAria = () => {
    const observer = new MutationObserver((mutations, obs) => {
      const el = document.querySelector('.g-recaptcha-response');

      if (el) {
        el.removeAttribute('aria-describedby');
        el.removeAttribute('aria-labelledby');
        el.setAttribute('aria-hidden', 'true');

        // Add this line to satisfy the "Missing form label" check for reCAPTCHA!
        el.setAttribute('aria-label', 'Google reCAPTCHA verification response');

        obs.disconnect();
      }
    });

    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  };



  return (
    <>
      {/*<Header handleLogout={handleLogout} />*/}
      {/*{isLoadingLogout || isLoadingCurrentUser ? (*/}
      {/*    <Loader show={true} />*/}
      {/*) : isErrorCurrentUser ? (*/}
      {/*    <NotFound />*/}
      {/*) : (*/}
      {/*    <Suspense fallback={<Loader show={true} />}>*/}
      {/*        <Outlet />*/}
      {/*    </Suspense>*/}
      {/*)}*/}
      {/*<CaasFooter />*/}


      {/*<Header handleLogout={handleLogout} />
       {isLoadingLogout || isLoadingCurrentUser ? (
        // <LoadingSkeletonBox height={"100px"} />
        <main id="main-content">
          <Outlet />
        </main>
      ) : isErrorCurrentUser ? (
        console.log("Error fetching current user: isErrorCurrentUser ->", isErrorCurrentUser),
        <NotFound />
      ) : (
        <main id="main-content">
          <Outlet />
        </main>

        // <Suspense fallback={<LoadingSkeletonBox />}>
        //   <main id="main-content">
        //     <Outlet />
        //   </main>
        // </Suspense>
      )} */}



      {/*<Header handleLogout={handleLogout} />
        <main id="main-content" >
         {isLoadingCurrentUser ? (
          <LoadingSkeletonBox height={"600px"} />
        ) : (
          <Suspense fallback={<LoadingSkeletonBox height={"3050px"} />}>
            <Outlet />
          </Suspense>
        )} 
      </main> */}



      <Header handleLogout={handleLogout} />

      <main id="main-content" >
        <Suspense fallback={<LoadingSkeletonBox height={"3055px"} />}>
          <Outlet />
        </Suspense>
      </main>

      <CaasFooter />

      <ConcurrentLoginModal
        show={isShowConcurrentLoginModal}
        onHide={() => setIsShowConcurrentLoginModal(false)}
      />

      {user?.userSessionValid && user.status === "ACTIVE" ? (
        <IdleTimeOutHandler
          onActive={() => {
            setIsActive(true);
          }}
          onIdle={() => {
            setIsActive(true);
          }}
          onLogout={handleLogout}
          continueSession={fetchUser}
        />
      ) : null}
    </>
  );
};

export default Root;
